import { useEffect, useState } from 'react';
import { IOrder, IProductCharacter } from '../../type';
import Price from '../price';
import Tag from '../tag';
import { renderGateway } from './success';

const AUTO_CLOSE_MS = 3000;

export default function PaymentCanceled({ order, onClose, character }: { order: IOrder; onClose: Function; character: IProductCharacter }) {
  const [countdown, setCountdown] = useState(Math.ceil(AUTO_CLOSE_MS / 1000));

  useEffect(() => {
    const tick = window.setInterval(() => {
      setCountdown((prev) => Math.max(0, prev - 1));
    }, 1000);
    const closeTimer = window.setTimeout(() => {
      onClose();
    }, AUTO_CLOSE_MS);

    return () => {
      window.clearInterval(tick);
      window.clearTimeout(closeTimer);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={"payment_box"}>
      <div className={"payment_container"}>
        <h1>Giao dịch thất bại</h1>
        <p>Bạn đã huỷ bỏ giao dịch với thông tin chi tiết</p>
        <p style={{ color: '#666', fontSize: 13, marginTop: -4 }}>
          Popup sẽ tự đóng sau {countdown}s
        </p>
        <div className={"info_box"}>
          {order?.serverId && order?.charId && (
            <>
              <div className={"info_item"}>
                <div className={"label"}>Máy chủ</div>
                <div className={"value"}>{order?.serverName || character?.serverName}</div>
              </div>
              <div className={"info_item"}>
                <div className={"label"}>Nhân vật</div>
                <div className={"value"}>{order?.charName || character.charName}</div>
              </div>
            </>
          )}
          <div className={"info_item"}>
            <div className={"label"}>Mệnh giá</div>
            <div className={"value"}><Price amount={order?.amount} currency={order?.currency} /></div>
          </div>
          <div className={"info_item"}>
            <div className={"label"}>Hình thức</div>
            <div className={"value"}>{renderGateway(order?.paymentGateway || order?.metadata?.paymentGateway)}</div>
          </div>
          {order?.paymentGatewayStatus && (
            <div className={"info_item"}>
              <div className={"label"}>Trạng thái</div>
              <div className={"value"}><Tag color="#ffa830">{order?.paymentGatewayStatus === 'failed' ? 'Thất bại' : order?.paymentGatewayStatus}</Tag></div>
            </div>
          )}
          {order?.paymentGatewayNote && (
            <div className={"info_item"}>
              <div className={"label"}>Lỗi</div>
              <div className={"value"}>{order?.paymentGatewayNote}</div>
            </div>
          )}
        </div>
        <div className="text-center" style={{ margin: '10px 0' }}>
          <button type="button" className='primary_btn' onClick={() => onClose()}>
            {`Thoát${countdown > 0 ? ` (${countdown}s)` : ''}`}
          </button>
        </div>
      </div>
    </div>
  );
}
